module.exports = __webpack_public_path__ + "static/media/Sahara_forest_crop_desktop.61221740.jpg";